export const CHECK_FROM_INVALID_DATE =
  'Check From Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const CHECK_TO_INVALID_DATE =
  'Check To Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const REC_FROM_INVALID_DATE =
  'Received From Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const REC_TO_INVALID_DATE =
  'Received To Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const SUS_FROM_INVALID_DATE =
  'Suspended From Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const SUS_TO_INVALID_DATE =
  'Suspended To Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const BATCH_FROM_INVALID_DATE =
  'Batch From Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const BATCH_TO_INVALID_DATE =
  'Batch To Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const POST_FROM_INVALID_DATE =
  'Postmarked From Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const POST_TO_INVALID_DATE =
  'Postmarked To Date-Please enter a date in the form in MM/YEAR or MM/DD/YEAR where year is 2 or 4 digits or a valid quarter and year in the form #Q## or #Q#### such as 1Q98 or 1Q1998.';
export const START_DATE_FUTURE_DATE = 'Start Date cannot be future date.';
export const CHECK_START_DATE_GRETERTHAN_END_DATE =
  'Check - To Date must be after From Date';
export const REC_START_DATE_GRETERTHAN_END_DATE =
  'Received - To Date must be after From Date';
export const SUS_START_DATE_GRETERTHAN_END_DATE =
  'Suspended - To Date must be after From Date';
export const BATCH_START_DATE_GRETERTHAN_END_DATE =
  'Batch - To Date must be after From Date';
export const POST_START_DATE_GRETERTHAN_END_DATE =
  'Postmarked - To Date must be after From Date';
export const ATLEAST_ONE_SEARCH_FIELD =
  'At least one data element must be entered in either Check Log Information or Search Dates.';
export const CHECK_INVALID_DATE =
  'Check Date-Please enter the date in  MM/YYYY or MM/DD/YYYY format where year is 2 or 4 digits.';
export const REC_INVALID_DATE =
  'Received Date-Please enter the date in  MM/YYYY or MM/DD/YYYY format where year is 2 or 4 digits.';
export const SUS_INVALID_DATE =
  'Suspended Date-Please enter the date in  MM/YYYY or MM/DD/YYYY format where year is 2 or 4 digits.';
export const BATCH_INVALID_DATE =
  'Batch Date-Please enter the date in  MM/YYYY or MM/DD/YYYY format where year is 2 or 4 digits.';
export const POST_INVALID_DATE =
  'Postmarked Date-Please enter the date in  MM/YYYY or MM/DD/YYYY format where year is 2 or 4 digits.';
export const FULLY_ALLOCATED =
  'This check is already marked as fully allocated.';
export const SUCCESS_MAINTAIN = 'System successfully saved the information!';
export const PARTIALLY_ALLOCATED =
  'You cannot delete a check that has been partially or fully allocated.';
export const DELETE_MAINTAIN = 'System successfully deleted the information!';
export const API_FAILED =
  'There was an error processing the request. Please retry the transaction.';
export const CHECK_PAYEE_VALIDATION = 'Check Payee is required';
export const CHECK_DATE_VALIDATION = 'Check Date is required';
export const CHECK_ISSUER_VALIDATION = 'Check Issuer is required';
export const NO_CHECK_FOUND =
  'No checks were found matching the provided criteria.';
export const VALID_ALTER_AMOUNT = 'Please enter a valid amount';
export const FULLY_ALLOCATED_CONFIRMATION =
  'Are you sure you want to mark this check as fully allocated?';